import React, { createContext, useContext, useEffect, useState } from 'react';

import cx from 'classnames';

export const THEME_CONTAINER_ID = 'overlayContainer';

type ThemeType = {
  light: string;
  dark: string;
};

type Props = {
  children: React.ReactNode;
  className?: string; // used for overriding with custom styles
};

const ThemeContext = createContext({
  theme: 'light',
  rebrand: false,
  toggleTheme: () => {},
  toggleRebrand: () => {},
});

const rebrandThemes: ThemeType = {
  light: 'newLightBeta',
  dark: 'newDarkBeta',
};

const legacyThemes: ThemeType = {
  light: 'light',
  dark: 'dark',
};

export const GlossDSThemeProvider = ({ children, className }: Props) => {
  const [rebrand, setRebrand] = useState(false);
  const [themes, setThemes] = useState<ThemeType>(
    rebrand ? rebrandThemes : legacyThemes,
  );
  const [theme, setTheme] = useState<keyof ThemeType>('light'); // Default theme

  const toggleTheme = () => setTheme(theme === 'light' ? 'dark' : 'light');

  const toggleRebrand = () => setRebrand(!rebrand);

  useEffect(() => {
    setThemes(rebrand ? rebrandThemes : legacyThemes);
  }, [rebrand]);

  return (
    <ThemeContext.Provider
      value={{ theme, toggleTheme, toggleRebrand, rebrand }}
    >
      <div
        id={THEME_CONTAINER_ID}
        className={cx(themes[theme], { rebrand: rebrand }, className)}
      >
        {children}
      </div>
    </ThemeContext.Provider>
  );
};

export const useGlossDSTheme = () => useContext(ThemeContext);
